// service-config-lint-disable: runtime-enriched-config-export-flow-covered -- this service is intentionally enriched at runtime, and the export flow already handles it as well.
import type { ILinkUtilsDefinition } from '@wix/viewer-service-link-utils/definition'
import { LinkUtilsDefinition as definition } from '@wix/viewer-service-link-utils/definition'
import { InternalLinkUtilsService as impl } from '@wix/viewer-service-link-utils/implementations/internalLinkUtilsService'
import type { LinkUtilsConfig } from '@wix/viewer-service-link-utils/types'
import { named, optional, withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'
import type { LinkUtilsServiceSiteConfig } from './types'
import type { IRoutingLinkUtilsAPI } from 'feature-router'
import { RoutingLinkUtilsAPISymbol } from 'feature-router'
import type { ILightboxUtils } from 'feature-lightbox'
import { LightboxUtilsSymbol } from 'feature-lightbox'

const wixLinkUtilsServiceFactory = withDependencies(
	[named(SiteFeatureConfigSymbol, name), RoutingLinkUtilsAPISymbol, optional(LightboxUtilsSymbol)],
	(
		siteConfig: LinkUtilsServiceSiteConfig,
		routingLinkUtilsAPI: IRoutingLinkUtilsAPI,
		lightboxUtils: ILightboxUtils
	): ServiceProvider<ILinkUtilsDefinition, typeof impl> => {
		const config: LinkUtilsConfig = {
			...siteConfig,
			routingInfo: routingLinkUtilsAPI.getLinkUtilsRoutingInfo(),
			popupPages: lightboxUtils?.getLightboxPages(),
		} as LinkUtilsConfig

		return {
			definition,
			impl,
			config,
			hasNonSerializablePlatformConfig: true,
		}
	}
)

export const WixLinkUtilsService: FactoryWithDependencies<ServiceProvider<ILinkUtilsDefinition>> =
	wixLinkUtilsServiceFactory
